(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["abris-delivery-date"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('abris-delivery-date')) {
    const selections = new Map();

    class AbrisDeliveryDate extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section');
        this.start = this.querySelector('[data-delivery-start]');
        this.end = this.querySelector('[data-delivery-end]');
        if (!this.scope || !this.start) return;

        const saved = selections.get(this.dataset.key);
        if (saved) {
          this.start.value = saved.start;
          if (this.end) this.end.value = saved.end;
        }

        this.abort = new AbortController();
        const { signal } = this.abort;

        this.addEventListener('input', () => this.update(), { signal });
        this.addEventListener('change', () => this.update(), { signal });

        this.scope.addEventListener(
          'submit',
          (event) => {
            if (event.target !== this.form) return;
            this.update();

            for (const input of [this.start, this.end].filter(Boolean)) {
              if (!input.checkValidity()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                input.reportValidity();
                return;
              }
            }
          },
          { capture: true, signal }
        );

        this.observer = new MutationObserver(() => this.bindForm());
        this.observer.observe(this.scope, { childList: true, subtree: true });
        this.bindForm();
        this.update();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.formAbort?.abort();
        this.property?.remove();
      }

      bindForm() {
        const form = this.scope.querySelector('product-form-component form[action*="/cart/add"]');
        if (!form || form === this.form) return;

        this.formAbort?.abort();
        this.property?.remove();
        this.form = form;
        this.formAbort = new AbortController();

        if (!form.id) form.id = `DeliveryForm-${this.dataset.key}`;
        for (const input of [this.start, this.end].filter(Boolean)) input.setAttribute('form', form.id);

        this.property = document.createElement('input');
        this.property.type = 'hidden';
        this.property.name = 'properties[Livraison souhaitée]';
        form.append(this.property);

        form.addEventListener(
          'formdata',
          (event) => {
            const value = this.preference();
            if (value) event.formData.set(this.property.name, value);
            else event.formData.delete(this.property.name);
          },
          { signal: this.formAbort.signal }
        );

        this.update();
      }

      update() {
        const today = new Date();
        today.setDate(today.getDate() + (Number(this.dataset.lead) || 0));

        const localDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
          today.getDate()
        ).padStart(2, '0')}`;

        const iso = /^\d{4}-\d{2}-\d{2}$/;
        const earliest = iso.test(this.dataset.earliest) ? this.dataset.earliest : '';

        this.start.min = earliest > localDate ? earliest : localDate;
        this.start.max = iso.test(this.dataset.latest) ? this.dataset.latest : '';
        this.start.required = this.dataset.required === 'true' || Boolean(this.end?.value);

        if (this.end) {
          this.end.min = this.start.value > this.start.min ? this.start.value : this.start.min;
          this.end.max = this.start.max;
          this.end.required = this.dataset.required === 'true' || Boolean(this.start.value);
        }

        for (const input of [this.start, this.end].filter(Boolean)) {
          input.dataset.hasValue = input.value ? 'true' : 'false';
        }

        selections.set(this.dataset.key, {
          start: this.start.value,
          end: this.end?.value || ''
        });

        const value = this.preference();

        if (this.property) {
          this.property.value = value;
          this.property.disabled = !value;
        }

        this.dispatchEvent(new CustomEvent('abris:delivery-change', { bubbles: true }));
      }

      preference() {
        if (
          !this.start.value ||
          !this.start.checkValidity() ||
          (this.end && (!this.end.value || !this.end.checkValidity()))
        ) {
          return '';
        }

        return this.end ? `${this.start.value} – ${this.end.value}` : this.start.value;
      }
    }

    customElements.define('abris-delivery-date', AbrisDeliveryDate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["abris-selection-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('abris-selection-summary')) {
    class AbrisSelectionSummary extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section');
        this.items = this.querySelector('.abris-summary__items');
        if (!this.scope || !this.items) return;
        this.variants = new Map(JSON.parse(this.querySelector('[data-summary-variants]').textContent).map(variant => [String(variant.id), variant]));
        this.total = this.querySelector('[data-summary-total]');
        this.lastRows = null;
        this.queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateSummary();
          });
        };
        this.onMutation = records => {
          if (records.some(record => !this.contains(record.target))) this.queueUpdate();
        };
        this.observer = new MutationObserver(this.onMutation);
        this.observer.observe(this.scope, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['aria-checked', 'checked', 'value', 'class', 'hidden', 'style', 'disabled']
        });
        this.scope.addEventListener('abris:delivery-change', this.queueUpdate);
        this.scope.addEventListener('change', this.queueUpdate);
        this.scope.addEventListener('input', this.queueUpdate);
        this.scope.addEventListener('click', this.queueUpdate);
        this.poll = setInterval(() => {
          if (!document.hidden) this.queueUpdate();
        }, 250);
        this.queueUpdate();
      }

      disconnectedCallback() {
        clearInterval(this.poll);
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.scope?.removeEventListener('abris:delivery-change', this.queueUpdate);
        this.scope?.removeEventListener('change', this.queueUpdate);
        this.scope?.removeEventListener('input', this.queueUpdate);
        this.scope?.removeEventListener('click', this.queueUpdate);
      }

      readSelection() {
        const form = this.scope.querySelector('product-form-component form[action*="/cart/add"]');
        const variantId = form?.querySelector('[name="id"]')?.value;
        const variant = this.variants.get(String(variantId ?? this.dataset.initialVariant));
        if (!variant) return null;
        const name = variant.label === 'Default Title' ? this.dataset.productTitle : `${this.dataset.productTitle} · ${variant.label}`;
        const rows = [[name, this.formatMoney(variant.price)]];
        let subtotal = variant.price;
        const selected = this.scope.querySelectorAll('input.tpo-checkbox-button:checked');
        for (const input of selected) {
          const container = input.closest('.tpo_option-container');
          if (input.disabled || container?.hidden || container?.classList.contains('tpo_hidden')) continue;
          if (container && getComputedStyle(container).display === 'none') continue;
          const label = input.closest('label')?.querySelector('.tpo_option_type_label');
          const name = label ? Array.from(label.childNodes)
            .filter(node => node.nodeType === Node.TEXT_NODE)
            .map(node => node.textContent).join(' ').trim() : '';
          const price = label?.querySelector('.tpo_additional-price')?.textContent
            .trim().replace(/^\(\s*/, '').replace(/\s*\)$/, '');
          if (!name || !price) return null;
          const cents = this.readMoney(price);
          if (cents === null) return null;
          subtotal += cents;
          rows.push([name, price]);
        }
        const delivery = this.scope.querySelector('abris-delivery-date');
        const preference = delivery?.preference?.();
        if (preference) rows.push([delivery.dataset.summaryLabel, preference]);
        const quantityInput = form?.elements.namedItem('quantity');
        const quantity = Math.max(1, Number(quantityInput?.value) || 1);
        return { rows, subtotal: subtotal * quantity };

      }

      readMoney(value) {
        let number = value.replace(/[^0-9.,−-]/g, '').replace('−', '-');
        if (!/\d/.test(number)) return null;
        const decimal = number.match(/[.,](\d{1,2})$/);
        if (decimal) {
          const position = number.length - decimal[0].length;
          number = number.slice(0, position).replace(/[.,]/g, '') + '.' + decimal[1];
        } else number = number.replace(/[.,]/g, '');
        const cents = Math.round(Number(number) * 100);
        return Number.isFinite(cents) ? cents : null;
      }

      formatMoney(cents) {
        const formats = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ','],
          amount_with_apostrophe_separator: [2, "'", '.']
        };
        const template = document.createElement('template');
        template.innerHTML = this.dataset.moneyFormat;
        const text = template.content.textContent;
        return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
          const [decimals, thousands, decimal] = formats[key] || formats.amount;
          const parts = (cents / 100).toFixed(decimals).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return parts.join(decimal);
        });
      }

      updateSummary() {
        const selection = this.readSelection();
        if (!selection) {
          this.hidden = true;
          this.lastRows = null;
          return;
        }
        const { rows, subtotal } = selection;
        const signature = JSON.stringify(selection);
        if (signature !== this.lastRows) {
          const fragment = document.createDocumentFragment();
          rows.forEach(([name, price]) => {
            const row = document.createElement('div');
            row.className = 'abris-summary__row';
            const term = document.createElement('dt');
            const value = document.createElement('dd');
            term.textContent = name;
            value.textContent = price;
            row.append(term, value);
            fragment.append(row);
          });
          this.items.replaceChildren(fragment);
          this.total.textContent = this.formatMoney(subtotal);
          this.lastRows = signature;
        }
        this.hidden = false;
      }
    }
    customElements.define('abris-selection-summary', AbrisSelectionSummary);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["starting-price"] && !Shopify.designMode) return;
  try {
    (() => {
    const startingPriceSelector =
      '.starting-price[data-hide-label-after-selection="true"]';

    const normalizeVariantId = (value) => {
      if (value == null) return '';

      const normalized = String(value).trim();

      if (!normalized) return '';

      return normalized.split('/').pop() || '';
    };

    const getScope = (element) => {
      if (!(element instanceof Element)) return null;

      return element.closest('.shopify-section, dialog');
    };

    const getStartingPrices = (scope) => {
      if (!scope) return [];

      return Array.from(
        scope.querySelectorAll(startingPriceSelector)
      );
    };

    const getPriceMap = (startingPrice) => {
      const script = startingPrice.querySelector(
        '[data-starting-price-variant-prices]'
      );

      if (!script) return {};

      try {
        return JSON.parse(script.textContent || '{}');
      } catch {
        return {};
      }
    };

    const hideLabel = (startingPrice) => {
      startingPrice.classList.add(
        'starting-price--label-hidden'
      );
    };

    const setVariantPrice = (
      startingPrice,
      variantId
    ) => {
      const id = normalizeVariantId(variantId);

      if (!id) return false;

      const priceMap =
        getPriceMap(startingPrice);

      const price = priceMap[id];

      if (!price) return false;

      const amount =
        startingPrice.querySelector(
          '[ref="priceContainer"]'
        );

      if (!amount) return false;

      amount.innerHTML = price;

      return true;
    };

    const syncStartingPrice = (
      scope,
      variantId = ''
    ) => {
      const id =
        normalizeVariantId(variantId);

      getStartingPrices(scope).forEach(
        (startingPrice) => {
          hideLabel(startingPrice);

          if (id) {
            setVariantPrice(
              startingPrice,
              id
            );
          }
        }
      );
    };

    document.addEventListener(
      'shopify:product:select',
      (event) => {
        if (
          !(event.target instanceof Element)
        ) {
          return;
        }

        const scope =
          getScope(event.target);

        if (!scope) return;

        const immediateVariantId =
          normalizeVariantId(
            event.detail?.variantId || ''
          );

        syncStartingPrice(
          scope,
          immediateVariantId
        );

        if (
          !event.promise ||
          typeof event.promise.then !== 'function'
        ) {
          return;
        }

        event.promise
          .then(({ variant, detail }) => {
            const resolvedVariantId =
              normalizeVariantId(
                detail?.resource?.id ||
                variant?.id ||
                ''
              );

            if (!resolvedVariantId) {
              return;
            }

            syncStartingPrice(
              scope,
              resolvedVariantId
            );
          })
          .catch(() => {});
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
